import getAjaxUrl from '../route/ajax-url';

const recalculateURL = 'ajax/recalculate/';

export class Requester {
  constructor(options = {}) {
    ({ showLoader: this.showLoader = true } = options);
    this.recalculateCalled = false;
  }

  recalculate(areasData, onSuccess, onError, breakerboardToButtJoint = false, closeLoaderAfterFinish = true) {
    if (this.showLoader) this.openLoader();
    this.recalculateCalled = true;
    this._makeRequest(JSON.stringify(areasData), onSuccess, onError, breakerboardToButtJoint, closeLoaderAfterFinish);
  }

  _makeRequest(areasData, onSuccess, onError, breakerboardToButtJoint, closeLoaderAfterFinish) {
    const successCallback = typeof onSuccess === 'function' ? onSuccess : () => {};
    const errorCallback = typeof onError === 'function' ? onError : () => {};
    try {
      const xhr = new XMLHttpRequest();
      const formData = new FormData();

      //use getAjaxUrl to obtain url in case cookies are deactivated
      xhr.open('POST', getAjaxUrl(recalculateURL));
      formData.append('action', 'recalculate');
      formData.append('areas', areasData);
      xhr.onload = () => {
        if (closeLoaderAfterFinish && this.showLoader) this.closeLoader();
        const response = JSON.parse(xhr.response);
        if (xhr.status === 200) {
          if (breakerboardToButtJoint) this._replaceBreakerboadWithButtjoint(response);
          successCallback(response);
        } else {
          errorCallback(response);
        }
      };

      xhr.onerror = () => {
        if (this.showLoader) this.closeLoader();
        errorCallback(JSON.parse(xhr.response));
      };

      xhr.send(formData);
    } catch (e) {
      if (this.showLoader) this.closeLoader();
      errorCallback({ error: 'parse_error' });
    }
  }

  openLoader() {
    com.parkside.loader.show(null, 'progress');
  }

  closeLoader() {
    com.parkside.loader.hide();
  }

  _replaceBreakerboadWithButtjoint(parsedResponse) {
    parsedResponse.forEach(rawArea => {
      if (rawArea.data.deck_type === 'breakerboard') rawArea.data.deck_type = 'buttjoint';
    });
  }
}
